/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react"
import { fileUploadOptions } from "../../helpers/fileHelpers"

interface IProps {
  className?: string
  name: string
  value?: string
  onChange: (e: React.ChangeEvent<any>) => void
  isDisabled?: boolean
  acceptedFileTypes?: string
}

const options = fileUploadOptions.acceptedFileTypes.join(", ")

const FileUploadField: React.FC<IProps> = ({ isDisabled = false, acceptedFileTypes = options, ...props }): JSX.Element => {
  return (
    <input
      className="cursor-pointer"
      id="file" name="file"
      type="file"
      disabled={isDisabled}
      accept={acceptedFileTypes}
      onChange={props.onChange}
    />
  )
}

export default FileUploadField
